import { z } from "zod";

export const PV_RECEPTION_TYPES = ["sans_reserve", "avec_reserve"] as const;
export type PvReceptionType = (typeof PV_RECEPTION_TYPES)[number];

export const pvReceptionDeclarationsSchema = z
  .object({
    receptionType: z.enum(PV_RECEPTION_TYPES),
    livrePropre: z.boolean(),
    kitBienvenueRecu: z.boolean(),
    receptionAt: z.string(), // ISO datetime, date & heure de réception
  })
  .partial();

export type PvReceptionDeclarations = z.infer<
  typeof pvReceptionDeclarationsSchema
>;
